import { Card } from '@mui/material'
import { experimentalStyled as styled } from '@mui/material/styles'

export const CardStandart = styled(Card)(({ theme }) => ({
	boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.08)',
	backgroundColor: 'white',
	borderRadius: '12px',
	'&:hover': { boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.15)' },
}))
